module.exports = __webpack_public_path__ + "bf.svg?57907e6611d0ab08eed5631443cdd447";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bf.svg
// module id = 1250
// module chunks = 0